import { render, staticRenderFns } from "./publicAdminAdd.vue?vue&type=template&id=3fd13254"
import script from "./publicAdminAdd.vue?vue&type=script&lang=js"
export * from "./publicAdminAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fd13254')) {
      api.createRecord('3fd13254', component.options)
    } else {
      api.reload('3fd13254', component.options)
    }
    module.hot.accept("./publicAdminAdd.vue?vue&type=template&id=3fd13254", function () {
      api.rerender('3fd13254', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/publicAdmin/publicAdminAdd.vue"
export default component.exports